const BASE_URL = "https://nexensus.club/cbi/";
const BASE_URL_LOCAL = "http://192.168.1.47:8070/";
export const API_LOGIN_URL = `${BASE_URL}user/login`;
export const REGISTER_OR_SAVEUSER_URL = `${BASE_URL}user/saveUser`;
export const SEND_OTP_URL = `${BASE_URL}email/sendOtp`;
export const VALIDATE_OTP_URL = `${BASE_URL}email/validateOtp`;
export const COMPANY_SEARCH_NAME_URL = `${BASE_URL}company/companySearch?byName=`;
export const NEWS_URL = `https://nexens.us/services/rssNewsFeed?fromDate=`;
